module.exports = {
    currentProject: 'yy'
};